module.exports = __webpack_public_path__ + "static/media/not-available-icon.87782606.svg";